import {
  ADD_MEDICINE_TO_CATEGORY_FAIL,
  ADD_MEDICINE_TO_CATEGORY_SUCCESS,
  CREATE_MEDICINE_CATEGORY_FAIL,
  CREATE_MEDICINE_CATEGORY_SUCCESS,
  DELETE_MEDICINE_OF_CATEGORY_FAIL,
  DELETE_MEDICINE_OF_CATEGORY_SUCCESS,
  GET_ADDED_MEDICINE_FAIL,
  GET_ADDED_MEDICINE_SUCCESS,
  GET_MEDICINE_CATEGORIES_FAIL,
  GET_MEDICINE_CATEGORIES_SUCCESS,
  GET_MEDICINE_DETAILS_FAIL,
  GET_MEDICINE_DETAILS_SUCCESS,
  GET_PART_MED_DETAILS_FAIL,
  GET_PART_MED_DETAILS_SUCCESS,
  GET_TASK_MED_DETAILS_FAIL,
  GET_TASK_MED_DETAILS_SUCCESS,
  GET_MED_DROP_LIST_FAIL,
  GET_MED_DROP_LIST_SUCCESS,
  SAVE_PART_MED_DETAILS_FAIL,
  SAVE_PART_MED_DETAILS_SUCCESS,
  UPDATE_PART_MED_DATA_FAIL,
  UPDATE_PART_MED_DATA_SUCCESS,
  UPDATE_MEDICINE_OF_CATEGORY_FAIL,
  UPDATE_MEDICINE_OF_CATEGORY_SUCCESS,
  DELETE_MEDICINE_DOC_SUCCESS,
  DELETE_MEDICINE_DOC_FAIL,
  REMOVE_MED_PART_PROFILE_SUCCESS,
  REMOVE_MED_PART_PROFILE_FAIL,
  ADD_MED_LIST_PARTICIAPNT_SUCCESS,
  ADD_MED_LIST_PARTICIAPNT_FAIL,
  UPDATE_PART_MED_LIST_SUCCESS,
  UPDATE_PART_MED_LIST_FAIL,
  GET_TASK_MED_REPORT_SUCCESS,
  GET_TASK_MED_REPORT_FAIL,
  GET_PARTICIPANT_MEDICATION_REPORT_SUCCESS,
  GET_PARTICIPANT_MEDICATION_REPORT_FAIL,
  GET_PART_MEDICINE_LOGS_SUCCESS,
  GET_PART_MEDICINE_LOGS_FAIL,
  GET_MEDICATION_LOG_SUCCESS,
  GET_MEDICATION_LOG_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  res: [],
  list: [],
  logs: [],
  error: [],
  details: [],
  medList: [],
  partMedList: [],
  dropMedList: [],
  taskMedDetails: [],
  taskMedReports: [],
  partMedDetails: [],
};

const Medication = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MEDICATION_LOG_SUCCESS:
      return {
        ...state,
        logs: action.payload,
      };
    case GET_MEDICATION_LOG_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PART_MEDICINE_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload,
      };
    case GET_PART_MEDICINE_LOGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_MED_LIST_PARTICIAPNT_SUCCESS:
      return {
        ...state,
        partMedList: action.payload,
      };
    case ADD_MED_LIST_PARTICIAPNT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TASK_MED_REPORT_SUCCESS:
      return {
        ...state,
        taskMedReports: action.payload,
      };
    case GET_TASK_MED_REPORT_FAIL:
      return {
        ...state,
        taskMedReports: action.payload,
        error: action.payload,
      };
    case GET_PARTICIPANT_MEDICATION_REPORT_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case GET_PARTICIPANT_MEDICATION_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_PART_MED_LIST_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_PART_MED_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REMOVE_MED_PART_PROFILE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case REMOVE_MED_PART_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_MEDICINE_DOC_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_MEDICINE_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SAVE_PART_MED_DETAILS_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case SAVE_PART_MED_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PART_MED_DETAILS_SUCCESS:
      return {
        ...state,
        partMedDetails: action.payload,
      };
    case GET_PART_MED_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MED_DROP_LIST_SUCCESS:
      return {
        ...state,
        dropMedList: action.payload,
      };
    case GET_MED_DROP_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TASK_MED_DETAILS_SUCCESS:
      return {
        ...state,
        taskMedDetails: action.payload,
      };
    case GET_TASK_MED_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MEDICINE_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload,
      };
    case GET_MEDICINE_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_MEDICINE_OF_CATEGORY_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_MEDICINE_OF_CATEGORY_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_MEDICINE_OF_CATEGORY_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_MEDICINE_OF_CATEGORY_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_MEDICINE_TO_CATEGORY_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_MEDICINE_TO_CATEGORY_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ADDED_MEDICINE_SUCCESS:
      return {
        ...state,
        medList: action.payload,
      };
    case GET_ADDED_MEDICINE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_PART_MED_DATA_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_PART_MED_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MEDICINE_CATEGORIES_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_MEDICINE_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CREATE_MEDICINE_CATEGORY_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case CREATE_MEDICINE_CATEGORY_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default Medication;
